import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import CustomBreadcrumb from '../../components/base/CustomBreadcrumb';
import BaseForm from '../../components/base/v2/BaseForm';
import MaintenanceStepOne from 'components/maintenance/MaintenanceStepOne';


function MaintenanceDetail({
  maintenanceDetail,
  hasUpdatedDefaultValues,
  formHasSubmitted,
}) {
  const dispatch = useDispatch();
  const [completeProcess, setShowCompleteProcess] = useState(false);

  useEffect(() => {
    dispatch({
      type: 'maintenance/getMaintenance',
      payload: {}
    });
  }, [dispatch]);

  const reset = () => {
    setShowCompleteProcess(false);
    dispatch({
      type: 'maintenance/resetStatus',
      payload: {}
    });
  };

  const stepContent = [
    <MaintenanceStepOne
      setShowCompleteProcess={setShowCompleteProcess}
    />,
  ];

  return (
    <>
      <BaseForm
        defaultValues={maintenanceDetail}
        hasUpdatedDefaultValues={hasUpdatedDefaultValues}
        formHasSubmitted={formHasSubmitted}
        tempSave={() => { }}
        stepsConfig={null}
        content={stepContent}
        currentStep={0}
        breadcrumb={
          <CustomBreadcrumb name="Maintenance" />
        }
        caution={{
          title: 'Maintenance',
          detail: 'Customers are not able to use the app during maintenance mode is on.',
        }}
        showFinishPop={completeProcess}
        nextStepConfig={{
          title: 'Successfully Saved!',
          description: '',
          steps: null,
          onHide: reset,
          buttons: [
            {
              text: 'Done',
              action: reset,
            },
          ],
        }}
        hasUnSavePrompt={false}
        hasCancelButton
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  maintenanceDetail: state.maintenance.maintenanceDetail,
  hasUpdatedDefaultValues: state.maintenance.hasUpdatedDefaultValues,
  formHasSubmitted: state.maintenance.formHasSubmitted,
});

export default connect(mapPropsToState)(MaintenanceDetail);
